// @flow
import React from 'react';
import classNames from 'classnames/bind';

import Tooltip from 'app/common/ui/Tooltip';
import PlainButtonAsLink from 'app/common/ui-next/plain-button-as-link';

import IconDownload from './icons/IconDownload';
import styles from './history-download-button.module.scss';;


const cx = classNames.bind(styles);

type Props = {
  className?: string,
  disabled?: boolean,
  toolTipText?: string,
  onClick: () => void | Promise<void>,
}

const HistoryDownloadButton = ({
  className,
  disabled,
  toolTipText = 'Скачать файл',
  onClick,
}: Props) => {
  return (
    <Tooltip text={toolTipText} className={className}>
      <PlainButtonAsLink onClick={onClick} disabled={disabled}>
        <IconDownload className={cx(styles.icon, { disabled })} />
      </PlainButtonAsLink>
    </Tooltip>
  );
};

export default HistoryDownloadButton;
